import { useNavigate } from 'react-router-dom';
import { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { api } from '@/lib/api';
import { toast } from 'sonner';
import { ArrowLeft, MailCheck } from 'lucide-react';
import { RegenLogo } from '@/components/RegenLogo';

export default function ForgotPassword() {
  const nav = useNavigate();
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post('/auth/forgot-password', { email });
      setSent(true);
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Something went wrong');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex flex-col justify-center px-6 max-w-md mx-auto">
      <button onClick={() => nav('/login')} data-testid="back-to-login" className="text-muted-foreground hover:text-foreground inline-flex items-center gap-2 text-sm mb-8"><ArrowLeft className="w-4 h-4" /> Back to login</button>
      <RegenLogo size="md" />
      {sent ? (
        <div className="mt-8 text-center" data-testid="reset-sent">
          <MailCheck className="w-12 h-12 text-[var(--c-green-ink)] mx-auto" />
          <h1 className="font-display font-black text-2xl mt-4">Check your email</h1>
          <p className="text-muted-foreground text-sm mt-2">If an account exists for <span className="text-foreground">{email}</span>, we've sent a password reset link. It expires in 1 hour.</p>
          <Button onClick={() => nav('/login')} className="mt-6 h-12 w-full bg-[#00C8FF] text-[#081726] font-semibold rounded-2xl">Back to Login</Button>
        </div>
      ) : (
        <>
          <h1 className="font-display font-black text-3xl mt-6 tracking-tight">Reset your password</h1>
          <p className="text-muted-foreground text-sm mt-2">Enter your email and we'll send you a reset link.</p>
          <form onSubmit={submit} className="mt-8 space-y-4">
            <div>
              <Label htmlFor="email">Email</Label>
              <Input id="email" type="email" data-testid="forgot-email" value={email} onChange={e => setEmail(e.target.value)} required className="mt-1.5 bg-regen-card border-[var(--c-hair)] h-12" />
            </div>
            <Button type="submit" disabled={loading} data-testid="forgot-submit" className="h-14 w-full bg-[#00C8FF] hover:bg-[#00C8FF]/90 text-[#081726] font-semibold rounded-2xl">
              {loading ? 'Sending…' : 'Send Reset Link'}
            </Button>
          </form>
        </>
      )}
    </div>
  );
}
